/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';

/**
 * 
 * @export
 * @interface GlobalReferentialsDto
 */
export interface GlobalReferentialsDto {
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    countries: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    nationalities: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    civilities: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    mandateFrequencies: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    legalForms: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    companyRoles: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    questionsContexts: Array<ReferentialDto>;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GlobalReferentialsDto
     */
    questionsTypes?: Array<ReferentialDto>;
}

/**
 * Check if a given object implements the GlobalReferentialsDto interface.
 */
export function instanceOfGlobalReferentialsDto(value: object): value is GlobalReferentialsDto {
    if (!('countries' in value) || value['countries'] === undefined) return false;
    if (!('nationalities' in value) || value['nationalities'] === undefined) return false;
    if (!('civilities' in value) || value['civilities'] === undefined) return false;
    if (!('mandateFrequencies' in value) || value['mandateFrequencies'] === undefined) return false;
    if (!('legalForms' in value) || value['legalForms'] === undefined) return false;
    if (!('companyRoles' in value) || value['companyRoles'] === undefined) return false;
    if (!('questionsContexts' in value) || value['questionsContexts'] === undefined) return false;
    return true;
}

export function GlobalReferentialsDtoFromJSON(json: any): GlobalReferentialsDto {
    return GlobalReferentialsDtoFromJSONTyped(json, false);
}

export function GlobalReferentialsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalReferentialsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'countries': ((json['countries'] as Array<any>).map(ReferentialDtoFromJSON)),
        'nationalities': ((json['nationalities'] as Array<any>).map(ReferentialDtoFromJSON)),
        'civilities': ((json['civilities'] as Array<any>).map(ReferentialDtoFromJSON)),
        'mandateFrequencies': ((json['mandateFrequencies'] as Array<any>).map(ReferentialDtoFromJSON)),
        'legalForms': ((json['legalForms'] as Array<any>).map(ReferentialDtoFromJSON)),
        'companyRoles': ((json['companyRoles'] as Array<any>).map(ReferentialDtoFromJSON)),
        'questionsContexts': ((json['questionsContexts'] as Array<any>).map(ReferentialDtoFromJSON)),
        'questionsTypes': json['questionsTypes'] == null ? undefined : ((json['questionsTypes'] as Array<any>).map(ReferentialDtoFromJSON)),
    };
}

export function GlobalReferentialsDtoToJSON(json: any): GlobalReferentialsDto {
    return GlobalReferentialsDtoToJSONTyped(json, false);
}

export function GlobalReferentialsDtoToJSONTyped(value?: GlobalReferentialsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countries': ((value['countries'] as Array<any>).map(ReferentialDtoToJSON)),
        'nationalities': ((value['nationalities'] as Array<any>).map(ReferentialDtoToJSON)),
        'civilities': ((value['civilities'] as Array<any>).map(ReferentialDtoToJSON)),
        'mandateFrequencies': ((value['mandateFrequencies'] as Array<any>).map(ReferentialDtoToJSON)),
        'legalForms': ((value['legalForms'] as Array<any>).map(ReferentialDtoToJSON)),
        'companyRoles': ((value['companyRoles'] as Array<any>).map(ReferentialDtoToJSON)),
        'questionsContexts': ((value['questionsContexts'] as Array<any>).map(ReferentialDtoToJSON)),
        'questionsTypes': value['questionsTypes'] == null ? undefined : ((value['questionsTypes'] as Array<any>).map(ReferentialDtoToJSON)),
    };
}

